import { deleteApi } from '../api/digitalVault';
import { repositoryOpts } from '../api/digitalVault';
export default async ({ name }, logger) => {
    return await deleteApi(`repository/${name}`, {}, { ...repositoryOpts.headers }, logger);
};
